import request from "@/utils/http";

// 用户主页
export function getUserHome(data) {
  return request({
    url: "/api/User/getUserHome",
    method: "get",
    params: data,
  });
}

// 用户关注
export function userFollow(data) {
  return request({
    url: "/api/UserFollow/changeStatus",
    method: "post",
    data: data,
  });
}

// 关注用户列表
export function followList(data) {
  return request({
    url: "/api/UserFollow/list",
    method: "get",
    params: data,
  });
}

//   关注游戏列表
export function GameFollow(data) {
  return request({
    url: "/api/GameFollow/list",
    method: "get",
    params: data,
  });
}

//   关注游戏
export function gameFollowChange(data) {
  return request({
    url: "/api/GameFollow/changeStatus",
    method: "post",
    data: data,
  });
}

//   metaMask登录
export function metaMaskLogin(data) {
  return request({
    url: "/api/Login/metaMaskLogin",
    method: "post",
    data: data,
  });
}
//  获取twitterURL
export function getTwitterUrl(data) {
  return request({
    url: "/api/Login/getTwitterUrl",
    method: "post",
    data: data,
  });
}
//  twitter登录
export function twitterLogin(data) {
  return request({
    url: "/api/Login/twitterLogin",
    method: "post",
    data: data,
  });
}

//  获取discordUrl
export function getDiscordUrl(data) {
  return request({
    url: "/api/Login/getDiscordUrl",
    method: "post",
    data: data,
  });
}

//  discord登录
export function discordLogin(data) {
  return request({
    url: "/api/Login/discordLogin",
    method: "post",
    data: data,
  });
}

//  获取Telegram
export function getTelegramUrl(data) {
  return request({
    url: "/api/Login/getTelegramUrl",
    method: "post",
    data: data,
  });
}

//  Telegram登录
export function telegramLogin(data) {
  return request({
    url: "/api/Login/telegramLogin",
    method: "post",
    data: data,
  });
}

//  google登录
export function googleLogin(data) {
  return request({
    url: "/api/Login/googleLogin",
    method: "post",
    data: data,
  });
}

//  用户信息修改
export function userEdit(data) {
  return request({
    url: "/api/User/edit",
    method: "post",
    data: data,
  });
}

// 头像列表
export function avatarList(data) {
  return request({
    url: "/api/User/avatarList",
    method: "get",
    params: data,
  });
}


// 经验值列表
export function userExpireList(data) {
  return request({
    url: "/api/User/userExpireList",
    method: "get",
    params: data,
  });
}

//  退出登录
export function logout(data) {
  return request({
    url: "/api/Login/logout",
    method: "post",
    data: data,
  });
}
// ai
export function chat(data) {
  return request({
    url: "/api/Chat/completions",
    method: "post",
    data: data,
  });
}

// 获取网站配置
export function config(data) {
  return request({
    url: "/api/Index/config",
    method: "get",
    params: data,
  });
}

// 订阅邮箱
export function Email(data) {
  return request({
    url: "/api/Email/subscribe",
    method: "post",
    data: data,
  });
}
